import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CalpadSSIDResoultion } from '../../service/calpad-ssid-resolution';
import { Student } from 'src/app/model/student/student.model';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { ShortDateTime } from 'src/app/pipes/short-date-time';
import { UnresolvedMatchTaskComponent } from './unresolved-match-task/unresolved-match-task.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-unresolved',
  templateUrl: './unresolved.component.html',
  styleUrl: './unresolved.component.scss'
})
export class UnresolvedComponent implements OnInit, AfterViewInit {

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  msg: MsgModel = {};
  isLoading = true;

  displayedColumns = [
    'Action',
    'Name',
    'MSDNumber',
    'SSID',
    'Dob',
    'Sex',
    'CalpadInquiryDate'
  ];

  tableDataSource = new MatTableDataSource<Student>();
  regionCode: string | null = '';

  constructor(
    private dialog: MatDialog,
    private calpadSSIDResoultion: CalpadSSIDResoultion,
    private route: ActivatedRoute
  ) {
    this.regionCode = this.route.snapshot.paramMap.get('code');
  }

  ngOnInit(): void {

    this.loadData();
  }

  ngAfterViewInit(): void {
    this.tableDataSource.paginator = this.paginator;
    this.tableDataSource.sort = this.sort;
  }

  setupSorting(sortState: Sort) {
    this.tableDataSource.sort = this.sort;
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    console.log('Filter Value:', filterValue); // Debugging line
    this.tableDataSource.filter = filterValue;

    if (this.tableDataSource.paginator) {
      this.tableDataSource.paginator.firstPage();
    }
  }
  
  goToPage(row: Student) {
    console.log(row.ID);
    console.log(row);
    const dialogRef = this.dialog.open(UnresolvedMatchTaskComponent, {
      width: '99%',
      data: row
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.isLoading = true;
        this.loadData();
      }
    });

  }
  private loadData(): void {
    this.calpadSSIDResoultion
      .getUnresolvedCounts(this.regionCode!)
      .subscribe(res => {
        const results: Student[] = res?.students || [];

        this.tableDataSource.data = results;
        this.isLoading = false;

        this.tableDataSource.sortingDataAccessor = (item, property) => {
          switch (property) {
            case 'Name':
              return [
                item.PERSON?.LAST_NAME || '',
                item.PERSON?.SECOND_LAST_NAME || '',
                item.PERSON?.FIRST_NAME || ''
              ].join(' ').toLowerCase();
            case 'MSDNumber':
              return item.MSD_NUMBER ? item.MSD_NUMBER.toLowerCase() : '';
            case 'Dob':
              return item.DOB ? new ShortDateTime('en-US').transform(item.DOB, 'short') || '' : '';
            case 'Sex':
              return item.SEX ? item.SEX.toLowerCase() : '';
            case 'CalpadInquiryDate':
              return item.CREATED_DATE ? new ShortDateTime('en-US').transform(item.CREATED_DATE, 'short') || '' : '';

            default:
              return (item as any)[property];
          }
        };
        this.tableDataSource.filterPredicate = (item: Student, filter: string) => {
          const lastName = item.PERSON?.LAST_NAME?.toLowerCase() || '';
          const secondLastName = item.PERSON?.SECOND_LAST_NAME?.toLowerCase() || '';
          const firstName = item.PERSON?.FIRST_NAME?.toLowerCase() || '';
          const middleInitial = item.PERSON?.MIDDLE_INITIAL?.toLowerCase() || '';
          const msdNumber = item.MSD_NUMBER?.toLowerCase() || '';
          const ssid = item.SSID?.toLowerCase() || '';
          const dob = item.DOB ? new ShortDateTime('en-US').transform(item.DOB, 'short')?.toLowerCase() || '' : '';
          const calpadInquiryDate = item.CREATED_DATE ? new ShortDateTime('en-US').transform(item.CREATED_DATE, 'short')?.toLowerCase() || '' : '';
          const sex = item.SEX?.toLowerCase() || '';
          // Combine name as displayed in template
          const fullName = `${lastName}${secondLastName ? ' ' + secondLastName : ''} ${firstName} ${middleInitial}`.toLowerCase();

          return fullName.includes(filter) ||
            msdNumber.includes(filter) ||
            ssid.includes(filter) ||
            dob.includes(filter) ||
            calpadInquiryDate.includes(filter) ||
            sex.includes(filter);

        };


        this.msg = results.length
          ? { SUCCESS: true, MSG: `Records Found ${results.length}` }
          : { SUCCESS: false, MSG: 'No Records' };
      });
  }
}
